import { render, staticRenderFns } from "./MedicalBagIcon.vue?vue&type=template&id=6af3e248&scoped=true&"
import script from "./MedicalBagIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MedicalBagIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3e248",
  null
  
)

export default component.exports